import React from 'react';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';

function ExportExcel(props) {
  const { applications, filename } = props;

  const [data, setData] = React.useState({});

  const exporter = React.useRef();

  const exportExcelFunction = () => {
    if (exporter.current) {
      exporter.current.save();
    }
  };

  function isValidDate(d) {
    return d instanceof Date && !isNaN(d);
  }

  const formatDate = (date) => {
    const event = new Date(date);
    if (!isValidDate(event)) return 'Sin fecha registrada';
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    const formattedDate = event.toLocaleDateString('es-ES', options);
    return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
  };

  React.useEffect(() => {
    const temp = (applications || []).reduce((acc, element) => {
      const data = { ...element };
      data.time = formatDate(element.time);
      data.process = !!element.process ? element.process : 'Pendiente';
      acc.push(data);
      return acc;
    }, []);
    setData(temp);
  }, [applications]);

  return (
    <>
      <button type="button" className="k-button k-primary" onClick={exportExcelFunction}>
        Exportar a Excel
      </button>
      <ExcelExport data={data} fileName={`${filename}.xlsx`} ref={exporter}>
        <ExcelExportColumn title="Vacante" field="jobTitle" />
        <ExcelExportColumn title="Empresa" field="companyName" />
        <ExcelExportColumn title="Ubicación" field="locationName" />
        <ExcelExportColumn title="Rango de salario" field="jobPay" />
        <ExcelExportColumn title="Fecha" field="time" />
        <ExcelExportColumn title="Estatus" field="process" />
      </ExcelExport>
    </>
  );
}

export default ExportExcel;
